declare namespace $ {

	type $mol_string__value_shm_surreal_table_1 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['search'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_surreal_table_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_select__value_shm_surreal_table_3 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['filter_field'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_surreal_table_4 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['filter_fields'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__Filter_shm_surreal_table_5 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_string__value_shm_surreal_table_6 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['filter_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_surreal_table_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_button_minor__title_shm_surreal_table_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_surreal_table_9 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['reload'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_surreal_table_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_surreal_table_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_surreal_table_grid__head_shm_surreal_table_12 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['columns'] >
		,
		ReturnType< $shm_surreal_table_grid['head'] >
	>
	type $shm_surreal_table_grid__objects_shm_surreal_table_13 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['rows'] >
		,
		ReturnType< $shm_surreal_table_grid['objects'] >
	>
	type $mol_view__sub_shm_surreal_table_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__value_shm_surreal_table_15 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['page_size'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_surreal_table_16 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['page_sizes'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__Filter_shm_surreal_table_17 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_paginator__value_shm_surreal_table_18 = $mol_type_enforce<
		ReturnType< $shm_surreal_table['page_number'] >
		,
		ReturnType< $mol_paginator['value'] >
	>
	type $mol_view__sub_shm_surreal_table_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_surreal_table extends $mol_view {
		Search( ): $mol_string
		filter_fields( ): Record<string, any>
		Filter_field( ): $mol_select
		Filter_value( ): $mol_string
		reload( next?: any ): any
		Reload( ): $mol_button_minor
		Toolbar( ): $mol_view
		status_text( ): string
		Status( ): $mol_view
		rows( ): readonly(any)[]
		Grid( ): $shm_surreal_table_grid
		count_text( ): string
		Count( ): $mol_view
		page_sizes( ): Record<string, any>
		Page_size( ): $mol_select
		Paginator( ): $mol_paginator
		Footer( ): $mol_view
		profile_id( ): string
		table_name( ): string
		columns( ): readonly(any)[]
		search_fields( ): readonly(any)[]
		search( next?: string ): string
		filter_field( next?: string ): string
		filter_value( next?: string ): string
		page_index( next?: number ): number
		page_size( next?: string ): string
		sub( ): readonly(any)[]
		page_number( next?: number ): number
	}
	
	type $mol_grid_cell__sub_shm_surreal_table_grid_1 = $mol_type_enforce<
		ReturnType< $shm_surreal_table_grid['cell_content'] >
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	export class $shm_surreal_table_grid extends $mol_grid {
		cell_content( id: any): readonly(any)[]
		head( ): readonly(string)[]
		objects( ): readonly(any)[]
		col_ids( ): ReturnType< $shm_surreal_table_grid['head'] >
		Cell_text( id: any): $mol_grid_cell
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map